<template>
  <div class="page">
    <top-header></top-header>
    <b-container fluid style="margin-top:5% !important">
      <b-row class="mt-3 mb-2">
        <b-col class="col-md-6 col-sm-6 col-xs-6">
          <h3>Download ULB Reports</h3>
        </b-col>
        <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
          <b-button variant="dark" pill class="mr-2" @click="showAddReportModal()">Generate Report cc1</b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <b-row>
        <b-col class="col-md-12 col-sm-12 col-xs-12">
          <div class="container-box">
            <b-row class="mt-4 px-3">
              <b-col lg="6">
                <span class="mr-2">Show</span>
                <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                </b-form-select>
                <span class="ml-2">entries</span>
              </b-col>
              <b-col lg="4" offset-md="2" class="text-right">
                <b-button variant="dark" pill class="mr-2" @click="downloadPDF()">Download PDF</b-button>
              </b-col>
            </b-row>
            <b-row class="px-3 pt-3">
              <b-col lg="12">
                <b-table
                  show-empty
                  sticky-header
                  small
                  striped
                  outlined
                  id="my-table"
                  stacked="md"
                  :items="records"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :filterIncludedFields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(status)="row">
                    <b-badge pill variant="danger" v-if="row.value == 0">PROCESSING</b-badge>
                    <b-badge pill variant="success" v-else>COMPLETE</b-badge>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <b-button
                      pill
                      variant="primary"
                      class="mr-1"
                      :href="$session.get('apiurl') + '/exports/' + row.item.link"
                      @click="download(row.item.id)"
                      target="_blank"
                      download
                      ><b-icon icon="arrow-down" scale="1.5"></b-icon>XLS</b-button
                    >
                    <b-button
                      pill
                      variant="primary"
                      class="mr-1"
                      :href="$session.get('apiurl') + '/exports/' + row.item.link.replace('.csv', '.pdf')"
                      @click="download(row.item.id)"
                      target="_blank"
                      download
                      ><b-icon icon="arrow-down" scale="1.5"></b-icon>PDF</b-button
                    >
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row class="px-3">
              <b-col lg="6">
                <span class="mr-2"
                  >Showing {{ currentPage }} to {{ perPage > records.length ? records.length : perPage }} of
                  {{ records.length }} entries</span
                >
              </b-col>
              <b-col lg="3" offset-md="3">
                <b-pagination
                  v-model="currentPage"
                  pills
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="right"
                  size="sm"
                  prev-text="Prev"
                  next-text="Next"
                  first-number
                  last-number
                ></b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-modal id="my-model" :title="modelTitle" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group label="State" label-cols="3" label-size="sm" label-align-sm="right">
            <b-form-select
              v-model="selectedItem.state"
              @change="
                selectedItem.district = 0;
                selectedItem.ulb = 0;
              "
            >
              <b-form-select-option value="0">--- Select State ---</b-form-select-option>
              <b-form-select-option v-for="item in $root.state_options" v-bind:key="item.id" :value="item.value">{{
                item.text
              }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
          <!--<b-form-group label="District" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select v-model="selectedItem.district" @change="selectedItem.ulb=0">
							<b-form-select-option value="0">--- Select District ---</b-form-select-option>
							<b-form-select-option v-for="item in filterZone(zones)" v-bind:key="item.id" :value="item.id">{{item.title}}</b-form-select-option>
						</b-form-select>
					</b-form-group>-->
          <b-form-group label="ULB" label-cols="3" label-size="sm" label-align-sm="right">
            <b-form-select v-model="selectedItem.ulb" :disabled="selectedItem.id > 0">
              <b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
              <b-form-select-option v-for="item in filterULB(zones)" v-bind:key="item.id" :value="item.id">{{
                item.title
              }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Start Date" label-cols="3" label-size="sm" label-align-sm="right">
            <b-form-datepicker
              v-model="selectedItem.start_date"
              :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
              :hide-header="true"
            ></b-form-datepicker>
          </b-form-group>
          <b-form-group label="End Date" label-cols="3" label-size="sm" label-align-sm="right">
            <b-form-datepicker
              v-model="selectedItem.end_date"
              :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
              :hide-header="true"
            ></b-form-datepicker>
          </b-form-group>
        </form>
        <template v-slot:modal-footer="{ ok, close }">
          <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
          <b-button size="sm" variant="success" @click="ok()"
            ><span
              class="spinner-border spinner-border-sm"
              v-if="loading_status"
              role="status"
              aria-hidden="true"
            ></span
            >&nbsp;{{ selectedItem.id > 0 ? "Update" : "Submit" }}</b-button
          >
        </template>
      </b-modal>
    </b-container>
    <transition name="fade">
      <b-row
        v-if="loading"
        class="loading"
        style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);"
        align-v="center"
        align-h="center"
      >
        <b-spinner label="Busy" variant="light"></b-spinner>
      </b-row>
    </transition>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  name: "Devices",
  components: {
    "top-header": Header,
  },
  mounted() {
    var self = this;
    Object.assign(self.selectedItem, self.emptyItem);
    this.loadzones();
  },
  data() {
    var self = this;
    return {
      loading: false,
      modelTitle: "",
      loading_status: false,
      password: "",
      zonesUrl: self.$session.get("apiurl") + "jhansiapi/zone-record",
      ulbreportUrl: self.$session.get("apiurl") + "jhansiapi/ulb-report",
      downloadUrl: self.$session.get("apiurl") + "jhansiapi/reports-download",
      filterselected: "",
      records: [],
      zones: [],
      fields: [
        { key: "date", label: "Date" },
        { key: "mode", label: "D/N" },
        { key: "total_device", label: "Total CCMS" },
        /*{ key: 'total_device_loss', label: 'Device Loss'},*/
        { key: "device_connected", label: "CCMS Connected" },
        /*{ key: 'total_device_on', label: 'Device ON'},
				{ key: 'total_device_off', label: 'Device OFF'},
				{ key: 'total_device_loss', label: 'Device Loss'},
                { key: 'total_controller', label: 'Total Lights' },
                { key: 'total_controller_on', label: 'Light ON' },
                { key: 'total_controller_off', label: 'Light OFF'},
                { key: 'total_controller_loss', label: 'Light Loss' },
                { key: 'total_load', label: 'Total Load',
					formatter: (value) => { 
						return (value/1000).toFixed(3);
					},
				},
                { key: 'actual_load', label: 'Actual Load',
                    formatter: (value) => {
						return (value/100000).toFixed(3)
					}
                    
                },
                { key: 'total_powercut', label: 'Power Cut' },
                { key: 'total_kwh', label: 'Total KWH',
					formatter: (value) => {
						return (value/100).toFixed(2);
					}
				},*/
        {
          key: "total_underload_kw",
          label: "Underload (No of fittings)",
          formatter: (value) => {
            return (value / 100).toFixed(0);
          },
        },
        {
          key: "total_overload_kw",
          label: "Overload (No of fittings)",
          formatter: (value) => {
            return (value / 100).toFixed(0);
          },
        },
        {
          key: "update_time",
          label: "Time",
          formatter: (value, key, item) => {
            if (item.update_time == "") {
              return "00:00";
            }
            return self.$moment(item.update_time).format("HH:mm");
          },
        },
      ],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      selectedItem: {
        state: this.$session.get("user_info").permissions.state_perm,
        district: "",
        ulb: "",
      },
      emptyItem: {
        id: 0,
        type: "",
        state: "",
        district: "",
        date: "",
      },
    };
  },
  methods: {
    filterZone: function(items) {
      var self = this;
      console.log("xxxx" + self.selectedItem.state);
      return items.filter(function(item) {
        if (item.parent == 0 && item.state == self.selectedItem.state) {
          return true;
        }
      });
    },
    filterULB: function(items) {
      var self = this;
      return items.filter(function(item) {
        return item.state == self.selectedItem.state;
      });
    },
    selectedULB: function(ulb) {
      var self = this;
      var title = "";
      self.zones.forEach((element) => {
        if (element.id == ulb) {
          title = element.title;
        }
      });
      return title;
    },
    showAddReportModal() {
      this.selectedItem = Object.assign({}, this.emptyItem);
      this.selectedItem.state = this.$session.get("user_info").permissions.state_perm = "in-jhansi";
      this.selectedItem.ulb = "";
      this.selectedItem.type = "ULB";
      this.modelTitle = "Generate Report";
      this.$root.$emit("bv::show::modal", "my-model");
    },
    showDeleteModal(item) {
      var self = this;
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete complaint.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            self.axios
              .post(self.deleteUrl, {
                accesskey: self.$session.get("access_key"),
                deleteid: item.id,
              })
              .then(function(response) {
                if (response.data.error == 0 || response.data.error == "0") {
                  self.$bvToast.toast(response.data.message, {
                    title: "Delete",
                    toaster: "b-toaster-bottom-right",
                    autoHideDelay: 5000,
                    variant: "warning",
                    solid: true,
                    appendToast: true,
                  });
                  self.initload();
                } else if (response.data.error == "2" || response.data.error == 2) {
                  self.$root.forceLogout(response.data.message);
                } else {
                  self.$root.showMessage("Server Error", "Reload again", "ok", function() {
                    self.initload();
                  });
                }
              })
              .catch(function(error) {
                alert(error);
              });
          } else {
            //alert('no '+item.id);
          }
        })
        .catch((err) => {
          // An error occurred
          console.log(err);
        });
    },
    modalSubmit(bvModalEvt) {
      var self = this;
      if (self.loading_status) {
        return;
      }
      self.loading_status = true;
      bvModalEvt.preventDefault();

      self.filterselected = self.selectedItem;

      self.axios
        .post(self.ulbreportUrl, {
          accesskey: self.$session.get("access_key"),
          data: self.selectedItem,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            var list = response.data.result.records;
            var zone = response.data.result.zone;

            //	self.records = list;

            var on_time = zone.on_time;
            var off_time = zone.off_time;

            //var start_time = selectedItem.start_date+' '+on_time+':00';
            //var end_time = selectedItem.end_date+' '+off_time+':00';

            var days =
              self
                .$moment(self.selectedItem.end_date, "YYYY-MM-DD")
                .diff(self.$moment(self.selectedItem.start_date, "YYYY-MM-DD"), "days") + 1;
            console.log("TOTAL DAYS " + days);

            var final_records = [];
            for (let i = 0; i < days; i++) {
              var start_day =
                self
                  .$moment(self.selectedItem.start_date, "YYYY-MM-DD")
                  .add(i, "days")
                  .format("YYYY-MM-DD") +
                " " +
                off_time +
                ":00";
              var end_day =
                self
                  .$moment(self.selectedItem.start_date, "YYYY-MM-DD")
                  .add(i, "days")
                  .format("YYYY-MM-DD") +
                " " +
                on_time +
                ":00";
              var start_night_first =
                self
                  .$moment(self.selectedItem.start_date, "YYYY-MM-DD")
                  .add(i, "days")
                  .format("YYYY-MM-DD") + " 00:00:00";
              var end_night_first =
                self
                  .$moment(self.selectedItem.start_date, "YYYY-MM-DD")
                  .add(i, "days")
                  .format("YYYY-MM-DD") +
                " " +
                off_time +
                ":00";
              var start_night_second =
                self
                  .$moment(self.selectedItem.start_date, "YYYY-MM-DD")
                  .add(i, "days")
                  .format("YYYY-MM-DD") +
                " " +
                on_time +
                ":00";
              var end_night_second =
                self
                  .$moment(self.selectedItem.start_date, "YYYY-MM-DD")
                  .add(i, "days")
                  .format("YYYY-MM-DD") + " 23:59:59";

              var day_total_device_on = 10000;
              var night_total_device_on = 0;
              var day_record = {};
              var night_record = {};
              for (let j = 0; j < list.length; j++) {
                var is_record_day = self
                  .$moment(list[j].update_time)
                  .isBetween(self.$moment(start_day), self.$moment(end_day));
                var is_record_night_first = self
                  .$moment(list[j].update_time)
                  .isBetween(self.$moment(start_night_first), self.$moment(end_night_first));
                var is_record_night_second = self
                  .$moment(list[j].update_time)
                  .isBetween(self.$moment(start_night_second), self.$moment(end_night_second));
                if (is_record_day) {
                  if (list[j].total_controller_on < day_total_device_on) {
                    Object.assign(day_record, list[j]);
                  }
                  day_total_device_on = Math.min(day_total_device_on, list[j].total_controller_on);
                }

                if (is_record_night_first) {
                  if (list[j].total_controller_on > night_total_device_on) {
                    Object.assign(night_record, list[j]);
                  }
                  night_total_device_on = Math.max(night_total_device_on, list[j].total_controller_on);
                }

                if (is_record_night_second) {
                  if (list[j].total_controller_on > night_total_device_on) {
                    Object.assign(night_record, list[j]);
                  }
                  night_total_device_on = Math.max(night_total_device_on, list[j].total_controller_on);
                }
              }
              day_record.date = self.$moment(start_day, "YYYY-MM-DD").format("DD-MM-YYYY");
              day_record.mode = "DAY";

              day_record.device_connected = parseInt(day_record.total_device) - parseInt(day_record.total_device_loss);

              night_record.date = self.$moment(start_day, "YYYY-MM-DD").format("DD-MM-YYYY");
              night_record.mode = "NIGHT";

              night_record.device_connected =
                parseInt(night_record.total_device) - parseInt(night_record.total_device_loss);

              final_records.push(day_record);
              final_records.push(night_record);
            }

            self.records = final_records;

            self.totalRows = self.records.length;

            self.$bvModal.hide("my-model");
            self.loading_status = false;
            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },

    downloadPDF() {
      var self = this;

      var pdfMake = require("pdfmake/build/pdfmake.js");
      var pdfFonts = require("pdfmake/build/vfs_fonts.js");
      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      var pdfdata = new Array();
      var data = new Array();
      self.fields.forEach((element) => {
        data.push(element.label);
      });
      pdfdata.push(data);
      for (var i = 0; i < self.records.length; i++) {
        data = new Array();
        self.fields.forEach((element) => {
          var value = self.records[i][element.key];

          if (element.key == "total_load") {
            value = (value / 1000).toFixed(3);
          }
          if (element.key == "actual_load") {
            value = (value / 100000).toFixed(3);
          }
          if (element.key == "total_kwh") {
            value = (value / 100).toFixed(2);
          }
          if (element.key == "total_underload_kw") {
            value = (value / 1000).toFixed(2);
          }
          if (element.key == "total_overload_kw") {
            value = (value / 1000).toFixed(2);
          }
          if (element.key == "total_kwh") {
            value = (value / 100).toFixed(2);
          }
          if (element.key == "update_time") {
            value = self.$moment(value).format("HH:mm");
          }
          data.push(value);
        });
        pdfdata.push(data);
      }

      var d = new Date();
      var uniq = d.getFullYear() + "-" + d.getMonth() + "-" + d.getDate() + "-" + d.getTime();
      var docDefinition = {
        content: [
          { text: "ULB Report : " + self.selectedULB(self.filterselected.ulb), style: "heading" },
          {
            text:
              "From: " +
              self.$moment(self.filterselected.start_date).format("DD-MM-YYYY") +
              " 00:00:00  To:  " +
              self.$moment(self.filterselected.end_date).format("DD-MM-YYYY") +
              " 23:59:59",
            style: "subheading",
          },
          {
            layout: "lightHorizontalLines",
            table: {
              headerRows: 1,

              body: pdfdata,
            },
          },
        ],
        styles: {
          heading: {
            fontSize: 20,
            alignment: "center",
            lineHeight: 2,
            bold: true,
          },
          subheading: {
            fontSize: 14,
            alignment: "center",
            lineHeight: 2,
            bold: false,
          },
        },
        defaultStyle: {
          fontSize: 10,
          bold: false,
        },
        pageOrientation: "landscape",
      };
      pdfMake.createPdf(docDefinition).download("REPORT_" + uniq + ".pdf");
    },

    resetSelectedItem() {
      var self = this;
      self.selectedItem = Object.assign({}, self.emptyItem);
    },
    loadzones() {
      var self = this;
      self.axios
        .post(self.zonesUrl, {
          accesskey: self.$session.get("access_key"),
          data: self.selectedItem,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.zones = response.data.result;
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
    initload() {
      var self = this;

      self.axios
        .post(self.recordsUrl, {
          accesskey: self.$session.get("access_key"),
          type: self.$route.params.reporttype,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            //var filteredarr = self.filtercategory(response.data.result);

            self.records = response.data.result.records;
            self.loading = false;
            self.totalRows = self.records.length;
            self.zones = response.data.result.zones;

            /*const zoneOptions = arr.reduce((acc, current) => {
						const x = acc.find(item => item.value === current.value);
						if (!x) {
							return acc.concat([current]);
						} else {
							return acc;
						}
					}, []);*/
            /*self.zoneOptions = [];
					self.records.forEach(function(item){
						if(item.parent == 0){
							self.zoneOptions.push({value:item.id, text:item.title, state:item.state});
						}
						
                    });*/

            /*self.$bvToast.toast(response.data.message, {
						title: 'Record Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});*/
          }
          setTimeout(self.initload, 1000 * 300);
        })
        .catch(function(error) {
          alert(error);
        });
      //alert('login '+self.email+" "+self.password);
    },
    /*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    download(row_id) {
      var self = this;

      self.axios
        .post(self.downloadUrl, {
          accesskey: self.$session.get("access_key"),
          id: row_id,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },
  },
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-color: "#FFF" !important;
  background-image: none !important;
}
.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
